
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenderIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tendersAgreements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenderIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processEnded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editWhileAgree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdditional"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"disagreeFormCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"disagreeFormVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreeFormCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreeFormVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusTitle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"agreeButtonTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"disagreeButtonTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideDisagreeButton"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":436}};
    doc.loc.source = {"body":"\nquery( $tenderIds: [Int]) {\n  tendersAgreements( tenderIds: $tenderIds ){\n    tenderId\n    comment\n    type\n    processEnded\n    agreements {\n      contactId\n      fio\n      isMy\n      status\n      reason\n      editWhileAgree\n      isAdditional\n      disagreeFormCode\n      disagreeFormVersion\n      agreeFormCode\n      agreeFormVersion\n      statusTitle\n    }\n    agreeButtonTitle\n    disagreeButtonTitle\n    hideDisagreeButton\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
